/**
 * Sprint 23.8 — workspace needs-attention hook.
 *
 * Wraps `list_workspace_needs_attention` for the hero card (which hides
 * entirely when this is empty). Polled every 30s (Q15 — status data) so a newly
 * blocked agent surfaces quickly. Pauses while the tab is hidden.
 */

import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";
import { useAuth } from "../../lib/hooks/use-auth";
import type { NeedsAttentionResult } from "../../lib/types";

const POLL_MS = 30_000;

export function useWorkspaceNeedsAttention() {
  const { currentWorkspaceId } = useAuth();
  return useQuery<NeedsAttentionResult>({
    queryKey: ["workspace-needs-attention", currentWorkspaceId],
    queryFn: () => mcpClient.listWorkspaceNeedsAttention(),
    enabled: !!currentWorkspaceId,
    staleTime: 15_000,
    refetchInterval: POLL_MS,
    refetchOnWindowFocus: true,
  });
}
